import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { Form, Input, Button, Row, Col } from "antd";
import "antd/dist/antd.css";
//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userLogin, LogOut } from "../global-state/actions/authAction";
import "../stylesheets/login.css";
import logo from "../images/iscore.png";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      BeErr: "",
    };
  }

  handleName = (e) => {
    this.setState({ email: e.target.value });
  };
  handlepass = (e) => {
    this.setState({ password: e.target.value });
  };

  onLogin = async (e) => {
    let loginrequest = {};
    loginrequest.email = this.state.email;
    loginrequest.password = this.state.password;

    const userData = await this.props.userLogin(
      loginrequest,
      this.props.history
    );
    // console.log(userData);
    if (userData) {
      this.setState({ BeErr: userData });
    }
  };

  componentDidMount() {
    this.props.LogOut();
  }

  onFinish = (values) => {
    // console.log("Success:", values);
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    return (
      <div>
        <Container className="py-3">
          <div className="login-logo">
            <img className="img-fluid iscore-logo" src={logo} alt="logo" />
          </div>
          {/* <h3>Login page</h3> */}
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            style={{
              background: "white",
              margin: "30px auto 0px auto",
              padding: "50px 100px",
              borderRadius: "20px",
              width: "50%",
            }}
          >
            {/* <img style={{width:'100px',height:'50px',marginBottom:'20px'}} src={logo} /> */}
            <h1
              style={{ fontFamily: "Poppins, sansSerif", textAlign: "center" }}
            >
               Signature Verification System{" "}
            </h1>
            <Form.Item
              // label="Email"

              name="Email"
              rules={[
                { required: true, message: "قم بإدخال البريد الالكتروني !" },
              ]}
            >
              <Input
                className="loginInput"
                placeholder="البريد الالكتروني"
                onChange={this.handleName}
                type="email"
              />
            </Form.Item>

            <Form.Item
              // label="Password"
              name="password"
              rules={[{ required: true, message: "قم بإدخال كلمه المرور!" }]}
            >
              <Input.Password
                value={this.state.password}
                onChange={this.handlepass}
                placeholder=" كلمه المرور"
                className="loginInput"
              />
            </Form.Item>
            {/* 
            <Form.Item name="remember" valuePropName="checked">
              <Checkbox>Remember me</Checkbox>
            </Form.Item> */}

            <Form.Item>
              <Button
                className="loginButton"
                onClick={this.onLogin}
                type="primary"
                htmlType="submit"
              >
                تسجيل
              </Button>
            </Form.Item>
          </Form>
          <Row>
            <Col style={{ margin: "auto" }} sm={12}>
              {this.state.BeErr !== "" ? (
                <p style={{ color: "red", fontWeight: "bold" }}>
                  {this.state.BeErr}
                </p>
              ) : null}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ userLogin, LogOut }, dispatch);
};
export default connect(null, mapDispatchToProps)(Login);
